module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"widgets-title":"Widgets"},"ua":{"widgets-title":"Віджети"},"ru":{"widgets-title":"Виджеты"}}')
  delete Component.options._Ctor
}
